<style scoped lang="less">
    .batteryPower{
        position: relative;
        min-height: 100vh;
        .tips{
            width: 80vw;
            height: 7vh;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 2.2vh;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
        }
        .wrapper{
            background-color: #fff;
            .house{
                font-size: 2.2vh;
                border-top: 1px solid transparent;
            }
            .bgr{
                width: 100vw;
                height: 2vh;
                background-color: #F3F3F3;
            }
            .controlBattery{
                font-size: 2.2vh;
                .batterySwitch{
                    border-top: 1px solid #ebedf0;
                    padding: 10px 15px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .currentText{
                        margin-right: 3vh;
                    }
                }

            }
        } 
    }
</style>
<template>
<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
    <div class="batteryPower">
            <div class="wrapper"  v-if="hasElectric">
                <div class="house">
                    <van-cell title="幸福小区"  :value="currentPosition" />
                    <van-cell title="当前电量"  :value="currentPower" />
                    <van-cell title="电路通断状态"  :value="currentStatus" />
                </div>
                <div class="bgr"></div>
                <div class="controlBattery">
                    <div class="batterySwitch">
                        <span class="currentText">通电控制</span>
                        <van-switch
                            :value="checked"
                            active-color="#07c160"
                            inactive-color="#f44"
                            @input="onInput"
                        />
                    </div>
                    <van-cell-group>
                        <van-field
                            v-model="time"
                            center
                            label="采集频率(秒)"
                            placeholder="请输入时间(单位秒)"
                        >
                            <van-button slot="button" size="small" type="primary" @click="send">修改</van-button>
                        </van-field>
                    </van-cell-group>
                </div>
            </div>
            <div class="tips" v-else>
                没有你的公寓公租房信息哦
            </div>
    </div>
    </van-pull-refresh>
</template>
<script>
import { Toast,DatetimePicker ,Picker,Popup,Cell,Switch,Dialog,CellGroup,Button,Field,PullRefresh } from "vant"
import api from "@/api/apartment"

export default {
    name:"apartment",
    components: {
        [Toast.name]: Toast,
        [DatetimePicker.name]: DatetimePicker,
        [Picker.name]: Picker,
        [Popup.name]:Popup,
        [Cell.name]:Cell,
        [Switch.name]:Switch,
        [Dialog.name]:Dialog,
        [Field.name]: Field,
        [Button.name]: Button,
        [CellGroup.name]: CellGroup,
        [PullRefresh.name]:PullRefresh
    },
    data() {
        return {
            currentPosition:"1幢2单元303室",
            currentPower:"",
            currentStatus:0,
            currentText:false,
            checked:true,
            time:60,
            hasElectric:true,
            list:{},
            id:'',
            isLoading:false
        };
    },
    created() {
       this.getEmeterInfo() 
    },
    methods:{
        getEmeterInfo(){
             api.getEmeterInfo({}).then(response=> {
                    if (response.result == 0) {
                       this.list=response.data;
                       this.time=response.data.intervals;
                       this.currentPower =(response.data.readingValue)/100+'kwh';
                       this.currentStatus=response.data.readingStatus==0?'通电':'断电';
                       if(response.data.controlStatus==2){
                           this.checked=response.data.readingStatus==0?true:false
                       }else{
                           this.checked=response.data.controlStatus==0?true:false
                       }
                       this.id=response.data.id
                    }else{
                        this.hasElectric=false;
                        Toast(response.message);
                    }
            })
        },
        onRefresh() {
            setTimeout(() => {
                this.getEmeterInfo();
                Toast('刷新成功');
                this.isLoading = false;
            }, 500);
        },
       onInput(checked) {
            Dialog.confirm({
                title: '提醒',
                message: '是否切换开关？'
            }).then(() => {
               this.changeStatus(this.id,checked)
            }).catch(() => {
            });
        },
        send(){
            Dialog.confirm({
                title: '提醒',
                message: '是否更改采集频率？'
            }).then(() => {
               this.changeIntervals(this.id)
            }).catch(() => {
            });
            
        },
        changeIntervals(id){
             api.controlIntervals(
                {
                   emeterId:id,
                   intervals:this.time
                }
                ).then(response=> {
                    if (response.result == 0) {
                        this.getEmeterInfo()   
                    }else{
                        Toast(response.message);
                    }         
            })
        },
        changeStatus(id,checked){
            api.controlStatus(
                {
                    emeterId:id,
                    status:checked==true?0:1
                }
                ).then(response=> {
                    if (response.result == 0) {
                          this.getEmeterInfo()
                    }else{
                        Toast(response.message);
                    }
            })
        }
    },
}
</script>
